// extracted by mini-css-extract-plugin
export default {"wrap":"progress-bar__wrap__Yw","fill":"progress-bar__fill__pD","label":"progress-bar__label__nw"};